import { INPUT_TYPES } from 'app-constants/inputTypes';

/* eslint-disable camelcase */
export const createText = () => ({
  type: 'text',
  varType: 'string',
  data: {},
});

export const createEmail = () => ({
  type: 'email',
  varType: 'string',
  data: [],
});

export const createPassword = () => ({
  type: 'password',
  varType: 'string',
  data: {
    subtype: '',
    size: 16,
    confirm: false,
    confirm_message: '',
    fail_message: '',
    pub: '',
  },
});

export const createBarcode = () => ({
  type: 'barcode',
  data: {},
});

export const createSignature = () => ({
  type: 'signature',
  data: {},
});

export const createCheckbox = () => ({
  type: 'checkbox',
  showIds: false,
  data: {},
});

export const createRadio = () => ({
  type: 'radio',
  showIds: false,
  varType: 'object',
  hasDynamicOptions: false,
  data: {},
});

export const createPhone = () => ({
  type: 'phone',
  varType: 'string',
  data: {},
});

export const createNumber = () => ({
  type: 'number',
  varType: 'number',
  data: {
    placeholder: '',
    integer: false,
    min: 0,
    max: 100,
  },
});

export const createDate = () => ({
  type: 'date',
  varType: 'string',
  data: {
    format: '',
    default: new Date(),
  },
});

export const createMedia = () => ({
  type: 'media',
  data: {
    media_type: '',
    picker: '',
    camera: '',
    geotag: false,
  },
});

export const createLocation = () => ({
  type: 'location',
  data: {
    subtype: '',
    format: '',
    timestamp: false,
    accuracy: false,
  },
});

export const injectValueText = (inputType, pattern, replacer) => ({
  type: inputType.type,
  method: inputType.method,
  data: { placeholder: inputType.data.placeholder?.replace(pattern, replacer) ?? '' },
});

export const injectValueNumber = (inputType, pattern, replacer) => ({
  type: inputType.type,
  method: inputType.method,
  data: {
    placeholder: inputType.data.placeholder?.replace(pattern, replacer) ?? '',
    integer: inputType.data.integer,
    min: inputType.data.min,
    max: inputType.data.max,
  },
});

export const injectValuePhone = (inputType, pattern, replacer) => ({
  type: inputType.type,
  method: inputType.method,
  data: { placeholder: inputType.data.placeholder?.replace(pattern, replacer) ?? '' },
});

export const injectValueEmail = (inputType, pattern, replacer) => ({
  type: inputType.type,
  method: inputType.method,
  data: { placeholder: inputType.data.placeholder?.replace(pattern, replacer) ?? '' },
});

export const injectValue = (inputType, pattern, replacer) => {
  // Si data es un string (variable dinámica), retornarlo tal
  if (typeof inputType.data === 'string') {
    return {
      type: inputType.type,
      data: inputType.data,
      method: inputType.method,
      ...(inputType.optionsVariable && { optionsVariable: inputType.optionsVariable }),
    };
  }

  // Si data es un objeto con opciones estáticas, procesarlas
  return {
    type: inputType.type,
    data: Object.keys(inputType.data).reduce((accum, key) => ({
      ...accum,
      [key]: {
        name: inputType.data[key].name.replace(pattern, replacer),
        value: inputType.data[key].id.replace(pattern, replacer),
      },
    }), {}),
    ...(inputType.optionsVariable && { optionsVariable: inputType.optionsVariable }),
  };
};

export const injectValuePassword = (inputType, pattern, replacer) => ({
  type: inputType.type,
  method: inputType.method,
  data: {
    subtype: inputType.data.subtype,
    size: inputType.data.size,
    confirm: inputType.data.confirm,
    confirm_message: inputType.data.confirm_message.replace(pattern, replacer),
    fail_message: inputType.data.fail_message.replace(pattern, replacer),
    pub: inputType.data.pub.replace(pattern, replacer),
  },
});

export const injectValueBarcode = (inputType, pattern, replacer) => ({
  type: inputType.type,
  data: {
    ...inputType.data,
    response: inputType.data.response?.replace(pattern, replacer) ?? '',
  },
});

export const injectValueSignature = (inputType, pattern, replacer) => ({
  type: inputType.type,
  data: {
    ...inputType.data,
    caption: inputType.data.caption?.replace(pattern, replacer) ?? '',
  },
});

export const injectValueDate = (inputType) => ({
  type: inputType.type,
  data: {
    format: inputType.data.format,
    placeholder: inputType.data.placeholder,
    ...(inputType.data.default && { default: inputType.data.default }),
  },
});

export const injectValueMedia = (inputType) => ({
  type: inputType.type,
  data: { ...inputType.data },
});

export const injectValueLocation = (inputType) => ({
  type: inputType.type,
  data: {
    subtype: inputType.data.subtype,
    format: inputType.data.format,
    timestamp: inputType.data.timestamp,
    accuracy: inputType.data.accuracy,
  },
  method: inputType.method,
});

export const injecVariablesInputType = (inputType, pattern, replacer) => {
  const injectorInputType = {
    [INPUT_TYPES.TEXT]: injectValueText,
    [INPUT_TYPES.NUMBER]: injectValueNumber,
    [INPUT_TYPES.PHONE]: injectValuePhone,
    [INPUT_TYPES.EMAIL]: injectValueEmail,
    [INPUT_TYPES.RADIO]: injectValue,
    [INPUT_TYPES.CHECKBOX]: injectValue,
    [INPUT_TYPES.PASSWORD]: injectValuePassword,
    [INPUT_TYPES.BARCODE]: injectValueBarcode,
    [INPUT_TYPES.SIGNATURE]: injectValueSignature,
    [INPUT_TYPES.DATE]: injectValueDate,
    [INPUT_TYPES.MEDIA]: injectValueMedia,
    [INPUT_TYPES.LOCATION]: injectValueLocation,
  };

  const injected = injectorInputType[inputType.type]?.(inputType, pattern, replacer) ?? inputType;
  return {
    ...injected,
    ...(inputType.timeout > 0 && { timeout: inputType.timeout }),
  };
};
